import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { indexOf, without, filter, find } from 'lodash';
import { connect } from 'react-redux';
import { Button, OverlayTrigger, Tooltip, Dropdown, MenuItem } from 'react-bootstrap';
import Fa from 'react-fontawesome';

import { getSavedSearches, getSavedSearch } from './search-form-reducer';
import { deleteSaveSearch, loadSaveSearch } from './search-form-actions';
import DateTimeDisplay from '../date-time-display';
import SaveSearchForm from './save-search-form';
import ConfirmButton from '../confirm-button';
import SearchField from '../search-field';
import ShareButton from './share-button';
import styles from './styles.css';

const MIN_RESULTS_TO_SEARCH = 10;

class SaveSearchList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deletingIds: [],
      activatingId: null,
      query: null,
    };
    this.setActive = this.setActive.bind(this);
    this.deleteSearch = this.deleteSearch.bind(this);
  }

  setActive(savedSearch) {
    const { type } = this.props;
    this.setState({ activatingId: savedSearch._id });
    this.props.dispatch(loadSaveSearch(type, savedSearch._id))
      .then(
        () => {
          this.props.onFilterSetLoad(savedSearch);
        },
        () => {

        },
      );
  }

  deleteSearch(savedSearch) {
    const id = savedSearch._id;
    const { type } = this.props;
    const { deletingIds } = this.state;
    let newDeletingIds = [...deletingIds];
    newDeletingIds.push(id);
    this.setState({ deletingIds: newDeletingIds });
    this.props.dispatch(deleteSaveSearch(type, id))
      .then(
        () => {
          newDeletingIds = without(newDeletingIds, id);
          this.setState({ deletingIds: newDeletingIds });
        },
        () => {
          newDeletingIds = without(newDeletingIds, id);
          this.setState({ deletingIds: newDeletingIds });
        },
      );
  }

  renderOwner(savedSearch) {
    const { owner } = savedSearch;
    if (owner) {
      const tip = (
        <Tooltip id={`shared-search-${savedSearch._id}`}>
          <div>Shared by {(owner.display_name || owner.nick_name || owner.username)}</div>
        </Tooltip>
      );
      return (<span>&nbsp;<OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}><Fa name="info-circle" className="text-active" /></OverlayTrigger></span>);
    }
    return null;
  }

  renderSystemSearches(searches) {
    if (!searches || searches.length === 0) {
      return null;
    }
    // const { activatingId } = this.state;
    // const activeSearch = activatingId ? find(searches, { _id: activatingId }) : null;
    const activeSearch = find(searches, { active: true });

    return (
      <div className="panel panel-defautl">
        <div className="panel-heading">
          <div className="panel-title">
          Current automation trigger conditions:
          </div>
        </div>
        <div className="panel-body">
          <div>
            <Dropdown
              id="system-searches"
            >
              <Dropdown.Toggle>
                <span>{activeSearch ? activeSearch.name : 'Automations'}</span>
              </Dropdown.Toggle>
              <Dropdown.Menu onSelect={this.setActive}>
                {searches.map((search) => {
                  return (
                    <MenuItem
                      eventKey={search}
                      key={search._id}
                      active={(activeSearch && activeSearch._id === search._id)}
                    >
                    <div>
                      {search.name} <Fa name="star" className={search.is_system ? 'text-warning' : 'invisible'} /> 
                    </div>
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { deletingIds, activatingId, query } = this.state;
    const {
      savedSearches, disabled, selectedSavedSearch, type, source,
    } = this.props;
    const searching = query !== null && query !== undefined && query.length > 0;
    const re = query && query.trim().length ? new RegExp(query, 'i') : null;
    const systemSearches = [];

    const items = filter(savedSearches, (data) => {
      let matchedName = true;
      let matchedDescription = true;
      if (data.is_automation) {
        if (data.source === source) {
          systemSearches.push(data);
        }
        return false;
      }
      if (re) {
        matchedName = (data.name || '').match(re);
        matchedDescription = (data.description || '').match(re);
      }
      return matchedName || matchedDescription;
    });

    const shouldShowSearchForm = items.length >= MIN_RESULTS_TO_SEARCH;

    
    const activeSearch = find(items, { active: true });
    const hasSelectedSavedSearch = activeSearch !== null && activeSearch !== undefined;
    // const somethingIsActive = activeSearch !== null && activeSearch !== undefined;
    const somethingIsActive = activatingId !== null;
                            
    const deleteTip = (
      <Tooltip id="saved-search-delete-tip">
        <div>Delete this search</div>
      </Tooltip>
    );
    const runTip = (
      <Tooltip id="saved-search-execute-tip">
        <div>Execute this search</div>
      </Tooltip>
    );

    return (
      <div className={styles.searchFormBody}>
        <div className="panel panel-defautl">
          <div className="panel-heading">
            <div className="panel-title">
              Your previous saved filter sets:
            </div>
          </div>
          <div className="panel-body">
            <div>
              {shouldShowSearchForm &&
                <div>
                  <SearchField collapsible={false} onSearch={(q) => { this.setState({ query: q }); }} />
                  <p />
                </div>
              }
              {items.length > 0 &&
                <div>
                  <table className="table table-condensed table-striped table-bordered">
                    <thead>
                      <tr>
                        {hasSelectedSavedSearch && <th width="10" />}
                        <th>Saved Filter Sets</th>
                        <th><nobr>Last Active</nobr></th>
                        <th width="200">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((savedSearch) => {
                        const isDeleting = indexOf(deletingIds, savedSearch._id) >= 0;
                        // const isActivating = savedSearch.active === true;
                        const isActivating = activatingId === savedSearch._id;
                        const isAutomation = savedSearch.is_automation === true;
                        return (
                          <tr key={savedSearch._id}>
                            {hasSelectedSavedSearch && <td>{savedSearch.active && <Fa name="circle" className="text-success animated flash infinite" />}</td>}
                            <td>
                              <div>
                                {savedSearch.name}
                                {!savedSearch.is_my_search && this.renderOwner(savedSearch)}
                              </div>
                              {savedSearch.description !== null && <div className="text-muted"><small>{savedSearch.description}</small></div>}
                            </td>
                            <td>
                              {savedSearch.last_used_date !== null && <DateTimeDisplay relative value={savedSearch.last_used_date} format="shortWithTime" />}
                            </td>
                            <td className="text-right">
                              {!isAutomation &&
                                <SaveSearchForm
                                  disabled={isDeleting || isActivating}
                                  bsStyle="default"
                                  title="Edit"
                                  savedSearch={savedSearch}
                                  tooltip="Edit this search"
                                  onModalShow={() => { this.props.onModalShow(); }}
                                  onModalHide={() => { this.props.onModalHide(); }}
                                  type={type}
                                >
                                  <Fa name="edit" />
                                </SaveSearchForm>
                              }
                              {!isAutomation &&
                                <ShareButton
                                  disabled={isDeleting || isActivating}
                                  bsStyle="default"
                                  title="Share"
                                  savedSearch={savedSearch}
                                  tooltip="Share this search"
                                  onModalShow={() => { this.props.onModalShow(); }}
                                  onModalHide={() => { this.props.onModalHide(); }}
                                >
                                  <Fa name="share" />
                                </ShareButton>
                              }
                              <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={runTip}>
                                <Button
                                  disabled={isDeleting || somethingIsActive}
                                  bsStyle="primary"
                                  onClick={() => { this.setActive(savedSearch); }}
                                >
                                  {!isActivating && <span><Fa name="bolt" /></span>}
                                  {isActivating && <span><Fa name="spinner" spin /></span>}
                                </Button>
                              </OverlayTrigger>
                              {!isAutomation &&
                                <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={deleteTip}>
                                  <ConfirmButton
                                    disabled={disabled || isDeleting || isActivating}
                                    confirmMessage="?"
                                    confirmStyle="danger"
                                    tooltip="Delete this search"
                                    onConfirm={() => { this.deleteSearch(savedSearch); }}
                                  >
                                    <Fa name="trash" />
                                  </ConfirmButton>
                                </OverlayTrigger>
                              }
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              }
              {items.length === 0 && <div className="well well-sm">No saved searches found.</div>}
              {re !== null && items.length === 0 &&
                <div className="alert alert-danger">
                  {searching && <span>No records found</span>}
                  {!searching && <span>No records found matching <code>{query}</code></span>}
                </div>
              }
            </div>
          </div>
        </div>
        {this.renderSystemSearches(systemSearches)}
      </div>
    );
  }
}

SaveSearchList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onModalShow: PropTypes.func,
  onModalHide: PropTypes.func,
  savedSearches: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  disabled: PropTypes.bool,
  onFilterSetLoad: PropTypes.func,
  selectedSavedSearch: PropTypes.shape({}),
  type: PropTypes.string.isRequired,
  source: PropTypes.string,
};
SaveSearchList.defaultProps = {
  onModalShow: () => {},
  onModalHide: () => {},
  onFilterSetLoad: () => {},
  disabled: false,
  selectedSavedSearch: null,
  source: 'opportunity',
};


// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  return {
    savedSearches: getSavedSearches(ownProps.type, state),
    selectedSavedSearch: getSavedSearch(ownProps.type, state),
  };
}

export default connect(mapStateToProps)(SaveSearchList);
